import { IPermissions, IUserOptions } from '../typings/userOptions';
import { action, makeObservable, observable } from 'mobx';

export interface IUserOptionsStore {
	readonly permissions: IPermissions;
	setPermissions: (permissions: IPermissions) => void;
}

export default class UserOptionsStore {
	public permissions: IPermissions = {};
	constructor(userOptions: IUserOptions) {
		this.permissions = userOptions.permissions;
		makeObservable(this, {
			permissions: observable,
			setPermissions: action.bound
		});
	}

	public setPermissions(permissions: IPermissions): void {
		this.permissions = permissions;
	}
}
